<template id="filter-layout-wrapper">
  <section class="bg-white xl:border-r xl:w-72">
    <div class="flex justify-between px-4 py-3 xl:hidden border-t border-grey-lighter">
      <div class="relative lg:max-w-xs w-full">
        <navbar-search></navbar-search>
      </div>
      <button type="button" class="inline-flex bg-grey-dark hover:bg-grey rounded px-4 ml-4 items-center text-sm" @click="toggle" :class="{ 'bg-grey-dark': isOpen, 'bg-grey-darker': !isOpen }">
        <font-awesome-icon :icon="['fas', 'filter']" class="text-white" />
        <span class="ml-2 text-white font-semibold">Filters</span>
      </button>
    </div>
    <form @submit.prevent="reset" :class="{ 'hidden': !isOpen, 'block': isOpen }" class="xl:block xl:h-full xl:flex xl:flex-col xl:justify-between xl:border-t border-grey-lighter">
      <div class="lg:flex xl:block xl:overflow-y-auto">
        <filter-date class="lg:py-6" @selected="add"/>
        <filter-sources class="lg:py-6" @selected="add"/>
        <filter-order-status class="lg:py-6" @selected="add"/>
        <div class="px-6 py-4 border-t border-grey-lighter lg:w-1/3 lg:border-l xl:w-full xl:border-l-0" v-if="complex">
          <span class="block text-sm font-semibold text-grey-darker">Complex</span>
          <div class="sm:flex sm:-mx-2 lg:block lg:mx-0">
            <label class="mt-4 sm:w-1/3 sm:px-2 flex items-center lg:w-full lg:px-0">
              <input type="radio" class="form-radio" :checked="true" @click.prevent="remove('filter[complex]')">
              <span class="ml-3">{{ complex.label }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="flex xl:flex-col justify-between border-t border-grey-lighter px-4 py-4 sm:text-right" v-if="isFiltered">
        <button class="block w-full sm:inline-block text-red-dark py-3 px-6 xl:block mr-auto bg-red-lightest rounded" @click="reset">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import NavbarSearch from '@/components/header/NavbarSearch';
import FilterDate from '@/components/filters/FilterDate';
import FilterOrderStatus from '@/components/filters/FilterOrderStatus';
import FilterSources from '@/components/filters/FilterSources';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { mapState } from 'vuex';
import { EventBus } from '@/event-bus';

export default {
  template: '#filter-layout-wrapper',
  name: 'FilterLayout',
  components: {
    FontAwesomeIcon,
    NavbarSearch,
    FilterDate,
    FilterOrderStatus,
    FilterSources
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapState('subject', {
      filters: state => state.filters
    }),
    complex() {
      return this.filters['filter[complex]'];
    },
    totalFilters() {
      return Object.keys(this.filters).length;
    },
    isFiltered() {
      return this.totalFilters > 3;
    }
  },
  methods: {
    add(filter) {
      this.$store.commit('subject/setFilters', {
        label: filter.label,
        key: `filter[${filter.type}]`,
        value: filter.value
      });
      this.submit();
    },
    remove(key) {
      this.$store.commit('subject/removeFilter', key);
      this.$emit('filtered');

      EventBus.$emit('filter-deleted', key);
      this.toggle();
    },
    reset() {
      this.$store.commit('subject/removeFilters');
      this.$emit('filtered');

      EventBus.$emit('filter-reset');
      this.isOpen = false;
    },
    submit() {
      this.toggle();
      this.$emit('filtered');
    },
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
